import * as API from '@/api/index'

/* 查询项目列表 */
export const findProjectList = (params) => {
    return API.POST('/A03OtherManagerController/findProjectList', params)
}

/* 查询投标供应商的标书信息 */
export const findBiddingSupplierDoc = (params) => {
    return API.POST('/A03OtherManagerController/findBiddingSupplierDoc', params)
}


/* 上传表述记录表 */
export const uploadDocument = (params) => {
    return API.POST('/A03OtherManagerController/uploadDocument', params)
}
/* 上传文件 */
export const filesUpload = (params) => {
    return API.POSTFILE('/A00CommonController/filesUploadNew', params)
}
/* 上传表述记录表 */
export const findLowestPrice = (params) => {
    return API.POST('/A03OtherManagerController/findLowestPrice', params)
}
